import { CREATE_COMMENT, createCommentSuccess, createCommentError, createCommentBusy } from "./action";
import { call, put, takeEvery } from "redux-saga/effects";
import { makeComment } from "./api";
import { ActionTypes } from "../util";
import { logError } from "utils/utils";

const { REQUEST } = ActionTypes;

export function* createCommentSaga(action) {
  const body = action.payload;
  try {
    yield put(createCommentBusy(true));
    yield put(createCommentError());
    const response = yield call(makeComment, body);
    yield put(createCommentSuccess(response));
  } catch (error) {
    logError(error);
    yield put(createCommentError(error.message));
  } finally {
    yield put(createCommentBusy(false));
  }
}

export default function* commentsSaga() {
  yield takeEvery(CREATE_COMMENT[REQUEST], createCommentSaga);
}
